import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { selectShiftPlanData } from '../../store/slices/shiftPlanSlice';
import { ROUTES } from '../../utils/constants';
import ShiftPlanTabs from '../shiftPlanTabs';

// Import page components
import RosterAndRates from '../../pages/rosterAndRates';
import InboundTrailerVolume from '../../pages/inboundTrailerVolume';
import VolumesAndWip from '../../pages/volumesAndWip/VolumesAndWipContainer';
import ReviewAndPublish from '../../pages/reviewAndPublish/reviewAndPublishContainer';

/**
 * ShiftPlanLayout component that provides persistent tabs and nested routing
 * for the shift planning workflow. Reads date/shift from Redux store.
 */
const ShiftPlanLayout: React.FC = () => {
  // Get shift plan data from Redux store
  const { selectedDate, selectedShift, selectedPlan, isShiftPlanActive } = useAppSelector(selectShiftPlanData);

  // If no shift plan is active, redirect to the main page
  if (!isShiftPlanActive || !selectedDate || !selectedShift) {
    return <Navigate to="/" replace />;
  }

  return (
    <ShiftPlanTabs
      date={selectedDate}
      shiftType={selectedShift}
      planType={selectedPlan}
      description="This page allows you to run and view the next shift plan and accept or override it."
    >
      <Routes>
        {/* Default route - redirect to roster */}
        <Route path="/" element={<Navigate to={ROUTES.SHIFT_PLAN_ROSTER} replace />} />
        
        {/* Tab content routes */}
        <Route path="/roster" element={<RosterAndRates />} />
        <Route path="/inbound-trailers" element={<InboundTrailerVolume />} />
        <Route path="/volumes" element={<VolumesAndWip />} />
        <Route path="/review" element={<ReviewAndPublish />} />
        
        {/* Fallback route */}
        <Route path="*" element={<Navigate to={ROUTES.SHIFT_PLAN_ROSTER} replace />} />
      </Routes>
    </ShiftPlanTabs>
  );
};

export default ShiftPlanLayout;
